<template>
  <div>
    <v-container class="ma-0 shipments-container">
      <v-row no-gutters>
        <v-col
        v-if="getSelectedView === 'overview'"
        cols="9"
        >
          <v-row
          no-gutters
          >
            <ShipmentsGroupByDayFiltersWrapper>
              <ShipmentsGroupByDayFilters />
            </ShipmentsGroupByDayFiltersWrapper>
            <v-col
            cols="12"
            lg="10"
            class="overview--groupbyday"
            :class="{'is-lg-and-up': $vuetify.breakpoint.lgAndUp}"
            >
              <ShipmentsGroupByDayOverview>
                <template v-slot:day="{ day }">
                  <DaysMetricMetadata
                    :day="day"
                    :open="handleIsOpenDay(day)"
                  >
                    <template v-slot:shipments="{ shipment }">
                      <ShipmentCardGroupByDay :shipment="shipment">
                        <template v-slot:carrier="{ shipment }">
                          <CarrierGroupByDay :shipment="shipment" />
                        </template>
                        <template v-slot:schedule="{ shipment }">
                          <ScheduleGroupByDay :shipment="shipment" />
                        </template>
                        <template v-slot:weight-volume="{ shipment }">
                          <WeightVolumeGroupByDay :shipment="shipment" />
                        </template>
                        <template v-slot:quotes="{ shipment }">
                          <QuotesGroupByDay :shipment="shipment" />
                        </template>
                        <template v-slot:icons="{ shipment }">
                          <IconsGroupByDay :shipment="shipment" />
                        </template>
                        <template v-slot:labels="{ shipment }">
                          <LabelsGroupByDay :shipment="shipment" />
                        </template>
                      </ShipmentCardGroupByDay>
                    </template>
                  </DaysMetricMetadata>
                </template>
              </ShipmentsGroupByDayOverview>
            </v-col>
          </v-row>
        </v-col>
        <v-col
        cols="9"
        v-if="getSelectedView !== 'overview'"
        >
          <ShipmentsGroupByDayDetail :selectedView="getSelectedView" />
        </v-col>
        <v-col cols="3" class="context">
          <v-row>
            <v-col cols="12" class="pt-0">
              <ShipmentsGroupByDayActions />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pt-0">
              <ShipmentsGroupByDayContext />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment-timezone'
import ShipmentsGroupByDayOverview from '@/components/shipmentsByDay/ShipmentsGroupByDayOverview'
import DaysMetricMetadata from '@/components/shipmentsByDay/DaysMetricMetadata'
import ShipmentCardGroupByDay from '@/components/shipmentsByDay/ShipmentCardGroupByDay'
import CarrierGroupByDay from '@/components/shipmentsByDay/CarrierGroupByDay'
import ScheduleGroupByDay from '@/components/shipmentsByDay/ScheduleGroupByDay'
import QuotesGroupByDay from '@/components/shipmentsByDay/QuotesGroupByDay'
import LabelsGroupByDay from '@/components/shipmentsByDay/LabelsGroupByDay'
import IconsGroupByDay from '@/components/shipmentsByDay/IconsGroupByDay'
import ShipmentsGroupByDayFiltersWrapper from '@/components/shipmentsByDay/filters/ShipmentsGroupByDayFiltersWrapper'
import ShipmentsGroupByDayFilters from '@/components/shipmentsByDay/filters/ShipmentsGroupByDayFilters'
import ShipmentsGroupByDayActions from '@/components/shipmentsByDay/context/ShipmentsGroupByDayActions'
import ShipmentsGroupByDayContext from '@/components/shipmentsByDay/context/ShipmentsGroupByDayContext'
import WeightVolumeGroupByDay from '@/components/shipmentsByDay/WeightVolumeGroupByDay'
import ShipmentsGroupByDayDetail from '@/components/shipmentsByDay/detail/ShipmentsGroupByDayDetail'

export default {
  name: 'ShipmentsByDay',
  components: {
      ShipmentsGroupByDayOverview,
      DaysMetricMetadata,
      ShipmentCardGroupByDay,
      CarrierGroupByDay,
      ShipmentsGroupByDayFiltersWrapper,
      ShipmentsGroupByDayFilters,
      LabelsGroupByDay,
      IconsGroupByDay,
      ScheduleGroupByDay,
      QuotesGroupByDay,
      ShipmentsGroupByDayActions,
      WeightVolumeGroupByDay,
      ShipmentsGroupByDayContext,
      ShipmentsGroupByDayDetail
  },
  data () {
    return {
      filterMenu: false,
      openDate: null
    }
  },
  mounted () {
    moment.tz.setDefault(moment.tz.guess())
  },
  methods: {
    ...mapActions({
      setResetState: 'shipmentsGroupByDay/setResetState',
      refinementListResetState: 'refinementListFilters/setResetState',
      rangesFiltersResetState: 'rangesFilters/resetState',
      numericsFiltersResetState: 'numericsFilters/setResetState'
    }),
    handleIsOpenDay (day) {
      const unixDay = moment(day.date).utc(true).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      }).unix()
      return unixDay === this.openDate
    }
  },
  computed: {
    ...mapGetters({
      getSelectedView: 'shipmentsGroupByDay/getSelectedView',
      getSelectedShipmentDate: 'shipmentsContext/getSelectedShipmentDate'
    }),
  },
  watch: {
    getSelectedView: {
      immediate: true,
      handler (val) {
        if (val === 'overview') {
          this.openDate = this.getSelectedShipmentDate
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.path.indexOf('shipments-by-day') < 0) {
      this.refinementListResetState()
      this.rangesFiltersResetState()
      this.numericsFiltersResetState()
    }
    next()
  },
  beforeDestroy() {
    this.setResetState()
  },
}
</script>

<style lang="scss" scoped>
  .shipments-container {
    max-width: 100%;
  }
  .cards {
      background: #D3D3D3;
  }
  .context {
      border-left: 2px solid #EBEAEB;
      // background: #DCDCDC;
  }
  .filters {
    border-right: 2px solid #EBEAEB;
  }
  .overview--groupbyday {
    &.is-lg-and-up {
      border-left: 2px solid #EBEAEB;
    }
  }
</style>
